import React from 'react';
import Classes from "classnames";
import removeSelfNotification from "../../../../../../core/gd/manager/misc/rate-experience/rate-experience-manager";

type Props = {
    fadeTime:  number
    data    :  any
    close   :  callback
}

export default function GrowlRateExperience(props: Props) {

    const onSmileClick = (e: React.MouseEvent, rating: number | null) => {
        e.stopPropagation();
        gd.modals.other.rateGoodDayExperience(rating);
        props.close();
    };

    const noThanks = () => {
        removeSelfNotification.markNoRateNeeded();
        props.close();
    };

    return (
        <div className={Classes("notification", "rate-experience", props.data.type)}
             style={{transition: "opacity "+props.fadeTime+"s"}}
             onClick={(e)=>{onSmileClick(e,null)}}>
            <div className="flex-row-center-center ui5-txt-default-small m-b-15">Please rate your GoodDay experience</div>
            <div className="flex-row-center-center m-b-15">

                <div className="smile" onClick={(e)=>{onSmileClick(e,1)}}>
                    <img src="/app/web/skin/common/svg/smiles/1.svg"/>
                </div>

                <div className="smile" onClick={(e)=>{onSmileClick(e,2)}}>
                    <img src="/app/web/skin/common/svg/smiles/2.svg"/>
                </div>

                <div className="smile" onClick={(e)=>{onSmileClick(e,3)}}>
                    <img src="/app/web/skin/common/svg/smiles/3.svg"/>
                </div>
                <div className="smile" onClick={(e)=>{onSmileClick(e,4)}}>
                    <img src="/app/web/skin/common/svg/smiles/4.svg"/>
                </div>
                <div className="smile" onClick={(e)=>{onSmileClick(e,5)}}>
                    <img src="/app/web/skin/common/svg/smiles/5.svg"/>
                </div>

            </div>
            <div className="flex-row-center-center">
                <div className="ui5-link-default" onClick={noThanks}>No, Thanks</div>
            </div>
        </div>
    )
}

